import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-all-services',
  templateUrl: './all-services.component.html'
})
export class AllServicesComponent implements OnInit {

  constructor(private globalSrv: GlobalServices) { }

  ngOnInit() { }
  navigate(url) {
     window.location.href = _spPageContextInfo.currentUICultureName == "ar-SA" ? "/Arabic" + url : "/English" + url;
    //window.location.href = "/English" + url;
    //window.location.href = "/Arabic" + url;
  }
}
